export const environment = {
    production: true,
    //apiRoot: "https: //www.ixellweblab.net/api",
    apiRoot: "https://www.ixellweblab.net/apiiwl",
    oauthRoot: "https://auth.groupe-lacour.net",
    colorWebOnlineRoot: "https://colorwebonline.lacour-electronique.net?iwl=true",
    colorCloudRoot: "https://www.partners.lacour-electronique.net/Identification/Login?iwl=true",
    serviceWorker: true,
    gaTrackingCode: ""
};
